import { toast } from 'react-toastify';
import axios from './axios-client';

export const makeFavorite = async (obj , setLoading = f => f, setIsMyFav, setError = f => f) => {
  try {
    setLoading(true)
    const data = await axios.post(`favorite`, obj);
    if(data?.data.faveriteWinery.winery === obj.wineryId){
      setIsMyFav(true)
    }
    setLoading(false);
    toast.success(data?.data.message);
  } catch (error) {
    setError(error);
    setLoading(false);
    toast.error(error.message);
  }
};

export const getMyFavorites = async ( userId, setData = f => f, setLoading = f => f, setError = f => f) => {
  try {
    setLoading(true)
    const data = await axios.get(`favorite/${userId}`);
    setData(data.data);
    setLoading(false)
  } catch (error) {
    setError(error);
    setLoading(false);
  }
};

export const removeMyFavorite = async (id , setData = f => f, favWineries, setError = f => f) => {
  try {
    // setLoading(true)
    const data = await axios.delete(`favorite/${id}`);
    let temp = favWineries;
    temp = temp.filter(t => t._id !== data.data.winery._id)
    console.log('data', data.data.winery);
    setData(temp);
    // setLoading(false);
    toast.success(data?.data.message);
  } catch (error) {
    setError(error);
    // setLoading(false);
    toast.error(error.message);
  }
};

